export interface SKURedirectRule {
  criteria: {
    SKUCodePrefix?: string[];
    SKUCode?: string[];
    SKUCodeRegex?: string;
  };
  redirectUrl?: string;
}

const matchesSKUCriteria = (criteria: SKURedirectRule['criteria'], skuCode: string): boolean => {
  const normalized = skuCode.toUpperCase();
  if (criteria.SKUCodePrefix?.some((prefix) => normalized.startsWith(prefix.toUpperCase())))
    return true;
  if (criteria.SKUCode?.map((s) => s.toUpperCase()).includes(normalized)) return true;
  if (criteria.SKUCodeRegex && new RegExp(criteria.SKUCodeRegex, 'i').test(skuCode)) return true;
  return false;
};

export const getRedirectUrlForSKU = (
  rules: SKURedirectRule[] | null | undefined,
  skuCode: string | null | undefined
): string | null => {
  if (!rules || !skuCode) return null;
  const match = rules.find((rule) => matchesSKUCriteria(rule.criteria, skuCode));
  return match?.redirectUrl || null;
};

export const matchesSKURules = (
  rules: SKURedirectRule[] | null | undefined,
  skuCode: string | null | undefined
): boolean => {
  if (!rules || !skuCode) return false;
  return rules.some((rule) => matchesSKUCriteria(rule.criteria, skuCode));
};
